import { render } from "./WhatsHappening.vue?vue&type=template&id=7fb72e6c"
import script from "./WhatsHappening.vue?vue&type=script&lang=js"
export * from "./WhatsHappening.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__